import { makeStyles } from '@fluentui/react-components';

import type { AllocationStats, LegendCounts } from '../use-month-stats';
import { AllocationSummaryCard } from './AllocationSummaryCard';
import { CapacityCard } from './CapacityCard';
import { PendingActionsCard } from './PendingActionsCard';

export type MonthSidebarProps = {
    stats: AllocationStats;
    pendingCount: number;
    legendCounts: LegendCounts;
    onBackfill: () => void;
    onApply: () => void;
    onResetPending: () => void;
};

export const MonthSidebar: React.FC<MonthSidebarProps> = ({ stats, pendingCount, legendCounts, onBackfill, onApply, onResetPending }) => {
    const classes = useStyles();
    return (
        <aside className={classes.root}>
            <CapacityCard stats={stats} onBackfill={onBackfill} />
            <AllocationSummaryCard stats={stats} counts={legendCounts} />
            <PendingActionsCard count={pendingCount} onApply={onApply} onReset={onResetPending} />
        </aside>
    );
};

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
        height: '100%',
        minHeight: 0,
    },
});
